module.exports = __webpack_public_path__ + "img/5.be00d33b.png";